function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
var marked = require('marked');
module.exports = function (app, mod, tx) {
  if (!tx) {
    return '<div class="view-post-error">No post data available</div>';
  }
  var msg = tx.returnMessage();
  var data = msg.data || {};
  var title = data.title || null;
  var subtitle = data.subtitle || null;
  var bodyText = data.content || data.text || '';
  var images = Array.isArray(data.images) ? data.images : [];
  var image = data.image || null;
  var imageUrl = data.imageUrl || null;
  var timestamp = tx.timestamp || data.timestamp || Date.now();
  var featureImageUrl = null;
  if (imageUrl && app.browser.isSafeMediaUrl(imageUrl)) {
    featureImageUrl = imageUrl;
  } else if (image) {
    var dataUrl = "data:image/png;base64,".concat(image);
    if (app.browser.isSafeMediaUrl(dataUrl)) {
      featureImageUrl = dataUrl;
    }
  }
  var imageMap = new Map();
  if (Array.isArray(images)) {
    var _iterator = _createForOfIteratorHelper(images),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var img = _step.value;
        if (img && img.id && img.data && img.mime) {
          imageMap.set(img.id, img);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  var renderMarkdown = function renderMarkdown(markdown) {
    if (!markdown) return '';
    var processedMarkdown = markdown;
    var imageReferenceRegex = /!\[([^\]]*)\]\(stack:image:([^)]+)\)/g;
    processedMarkdown = processedMarkdown.replace(imageReferenceRegex, function (match, alt, imageId) {
      var imageObj = imageMap.get(imageId);
      if (imageObj && imageObj.data) {
        var mimeType = imageObj.mime || 'image/png';
        var _dataUrl = "data:".concat(mimeType, ";base64,").concat(imageObj.data);
        return "![".concat(alt, "](").concat(_dataUrl, ")");
      } else {
        console.warn('Stack: Image reference not found:', imageId);
        var placeholderUrl = '/saito/img/dreamscape.png';
        return "![".concat(alt || 'Image not found', "](").concat(placeholderUrl, ")");
      }
    });
    var html = '';
    processedMarkdown = processedMarkdown.replace(/!\[([^\]]*)\]\((data:image\/[^)]+)\)/g, function (_, alt, dataUrl) {
      if (!app.browser.isSafeMediaUrl(dataUrl)) {
        return '';
      }
      return "<img src=\"".concat(app.browser.escapeHTML(dataUrl), "\" alt=\"").concat(app.browser.escapeHTML(alt || ''), "\" />");
    });
    var markdownHtml = marked.parse(processedMarkdown);
    if (app.browser.sanitize) {
      html = app.browser.sanitize(markdownHtml, false);
    } else {
      html = app.browser.escapeHTML ? app.browser.escapeHTML(markdownHtml) : markdownHtml;
    }
    html = html.replace(/<h1[^>]*>/gi, '<h2>');
    html = html.replace(/<\/h1>/gi, '</h2>');
    return html;
  };
  var processedBody = renderMarkdown(bodyText);
  var hasTitle = title && title.trim().length > 0;
  var hasSubtitle = subtitle && subtitle.trim().length > 0;
  var hasBody = processedBody && processedBody.trim().length > 0;
  if (!hasTitle && !hasBody) {
    return '<div class="view-post-error">No post content available</div>';
  }
  var authorPublicKey = tx.from && tx.from.length > 0 ? tx.from[0].publicKey || tx.from[0].address || '' : '';
  var authorLabel = 'Author';
  var authorIsAddress = false;
  if (authorPublicKey) {
    if (authorPublicKey === mod.STACK_OFFICIAL_PUBLICKEY) {
      authorLabel = 'SaitoOfficial';
    } else if (authorPublicKey === mod.publicKey) {
      authorLabel = 'My Posts';
    } else if (app.keychain && typeof app.keychain.returnUsername === 'function') {
      authorLabel = app.keychain.returnUsername(authorPublicKey) || authorLabel;
      authorIsAddress = true;
    }
  }
  var authorCrumbHTML = authorIsAddress ? "<span class=\"saito-address\" data-id=\"".concat(app.browser.escapeHTML(authorPublicKey), "\" data-disable=\"true\">").concat(app.browser.escapeHTML(authorLabel), "</span>") : app.browser.escapeHTML(authorLabel);
  var displayTitle = hasTitle ? title.trim() : 'Untitled post';
  var stackHomePath = mod.returnStackPath ? mod.returnStackPath() : "/".concat(mod.slug);
  var authorFeedPath = authorPublicKey ? mod.returnStackPath ? mod.returnStackPath(authorPublicKey) : "/".concat(mod.slug, "/").concat(authorPublicKey) : stackHomePath;
  return "\n    <div class=\"view-post\">\n      <article class=\"article\">\n        <nav class=\"breadcrumb\" aria-label=\"Breadcrumb\">\n          <a class=\"crumb\" href=\"".concat(app.browser.escapeHTML(stackHomePath), "\">Saito Stack</a>\n          <span class=\"sep\" aria-hidden=\"true\">&gt;</span>\n          <a class=\"crumb\" href=\"").concat(app.browser.escapeHTML(authorFeedPath), "\">").concat(authorCrumbHTML, "</a>\n          <span class=\"sep\" aria-hidden=\"true\">&gt;</span>\n          <span class=\"current\">").concat(app.browser.escapeHTML(displayTitle), "</span>\n        </nav>\n\n        ").concat(featureImageUrl ? "\n          <div class=\"feature\">\n            <img src=\"".concat(app.browser.escapeHTML(featureImageUrl), "\" alt=\"").concat(hasTitle ? app.browser.escapeHTML(title) : 'Post image', "\" />\n          </div>\n        ") : '', "\n\n        <header class=\"header\">\n          ").concat(hasTitle ? "\n            <h1 class=\"title\">".concat(app.browser.escapeHTML(title), "</h1>\n          ") : '', "\n\n          ").concat(hasSubtitle ? "\n            <p class=\"subtitle\">".concat(app.browser.escapeHTML(subtitle), "</p>\n          ") : '', "\n\n          <div class=\"attribution\">\n            <div id=\"stack-view-post-author-container\" class=\"author\">\n              <!-- SaitoUser component will be rendered here by JavaScript -->\n            </div>\n\n            <div class=\"actions\">\n              <a href=\"#\" id=\"stack-view-post-build-on\" class=\"badge is-hidden\" aria-label=\"Edit\" title=\"Edit\">\n                <i class=\"fa-solid fa-pencil\"></i>\n              </a>\n              <a href=\"#\" id=\"stack-view-post-subscribe\" class=\"badge is-hidden\" aria-label=\"Follow\" title=\"Follow\">\n                <i class=\"fa-solid fa-user-plus\"></i>\n              </a>\n              <a href=\"#\" id=\"stack-view-post-share\" class=\"badge\" aria-label=\"Share Post\" title=\"Share Post\">\n                <i class=\"fa-solid fa-share-nodes\"></i>\n              </a>\n            </div>\n          </div>\n        </header>\n\n        ").concat(hasBody ? "\n          <div class=\"body\">\n            <div class=\"content richtext-content\">\n              ".concat(processedBody, "\n            </div>\n          </div>\n        ") : '', "\n      </article>\n    </div>\n  ");
};